<template>
  <div class="fd-flex fd-items-start fd-h-full fd-bg-white">
    <div class="fd-w-full fd-h-full fd-bg-theme-1 fd-text-white fd-pl-20 fd-pr-28">
      <div class="fd-mt-4 fd-mb-9">
        <svg width="96" height="70" viewBox="0 0 96 70" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.283203 63.9033H55.7565V64.991H0.283203V63.9033Z" fill="#202A21"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M86.7539 0L86.7539 42.1488L85.6662 42.1488L85.6662 4.75454e-08L86.7539 0Z" fill="#202A21"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.73047 69.8848L2.73047 20.3939L3.81818 20.3939L3.81818 69.8848L2.73047 69.8848Z" fill="#202A21"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 26.1514L95.7061 1.35632L96 2.39886L0.293861 27.1939L0 26.1514Z" fill="#202A21"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M93.8238 6.25488V53.544H87.8934V13.8029L11.3776 32.3861V56.0646H46.8769V62.0001H5.44727V27.7187L93.8238 6.25488Z" fill="#202A21"/>
          <path d="M25.0273 32.9618H27.8871V47.8542C28.2398 47.8542 28.6051 47.8499 28.9831 47.8415C29.3694 47.833 29.7515 47.8245 30.1295 47.816C30.5158 47.8075 30.8895 47.799 31.2507 47.7905C31.6202 47.7736 31.9688 47.7566 32.2963 47.7396C33.069 47.7057 33.8248 47.6717 34.5639 47.6378C34.5639 47.7821 34.5429 47.9984 34.5009 48.287C34.4673 48.5755 34.4253 48.8682 34.3749 49.1652C34.3246 49.4537 34.2742 49.7083 34.2238 49.9289C34.1818 50.1411 34.1482 50.2471 34.123 50.2471H25.0273V32.9618Z" fill="#284A33"/>
          <path d="M40.6547 32.9618H44.9506L50.0653 50.2471H47.2056L45.6435 44.9648H40.113L38.6265 50.2471H35.6912L40.6547 32.9618ZM45.0514 42.75L42.746 34.2728L40.6673 42.75H45.0514Z" fill="#284A33"/>
          <path d="M51.5579 49.6234C51.5747 49.4283 51.6041 49.2076 51.6461 48.9616C51.6881 48.7579 51.7427 48.5161 51.8099 48.236C51.8855 47.9475 51.9946 47.6378 52.1374 47.3069C52.5909 47.4596 53.0529 47.5954 53.5232 47.7142C53.9263 47.816 54.3672 47.9093 54.846 47.9942C55.3247 48.0791 55.7824 48.1215 56.2191 48.1215C56.8826 48.1215 57.4369 48.0706 57.882 47.9687C58.3356 47.8669 58.6967 47.7184 58.9655 47.5232C59.2426 47.3196 59.44 47.0693 59.5576 46.7723C59.6751 46.4668 59.7339 46.1146 59.7339 45.7158C59.7339 45.266 59.6709 44.8842 59.545 44.5702C59.4274 44.2562 59.2426 43.9847 58.9907 43.7556C58.7471 43.5265 58.4321 43.3313 58.0458 43.1701C57.6595 43.0089 57.2018 42.8519 56.6726 42.6991C55.7488 42.4446 54.9677 42.1688 54.3294 41.8718C53.6912 41.5663 53.1704 41.2184 52.7673 40.828C52.3726 40.4377 52.087 39.9964 51.9107 39.5043C51.7343 39.0036 51.6461 38.4351 51.6461 37.7986C51.6461 36.8822 51.7847 36.0973 52.0618 35.4439C52.3474 34.7905 52.7463 34.2559 53.2586 33.8401C53.7793 33.4243 54.405 33.1188 55.1357 32.9236C55.8748 32.7284 56.6978 32.6309 57.6049 32.6309C58.302 32.6309 58.9109 32.686 59.4316 32.7963C59.9607 32.9066 60.4058 33.0254 60.7669 33.1527C61.1869 33.3055 61.5522 33.4794 61.863 33.6746C61.8378 33.8698 61.7874 34.0819 61.7118 34.311C61.6446 34.5062 61.5522 34.7353 61.4346 34.9984C61.3171 35.2614 61.1533 35.5457 60.9433 35.8512C60.6914 35.6815 60.3974 35.5287 60.0615 35.393C59.7675 35.2742 59.4106 35.1681 58.9907 35.0747C58.5791 34.9729 58.1004 34.922 57.5545 34.922C56.9582 34.922 56.4543 34.9687 56.0428 35.062C55.6396 35.1554 55.3079 35.3039 55.0475 35.5075C54.7872 35.7027 54.5982 35.953 54.4806 36.2585C54.3714 36.5555 54.3168 36.9119 54.3168 37.3277C54.3168 37.7944 54.3756 38.1847 54.4932 38.4987C54.6108 38.8042 54.7998 39.0673 55.0601 39.2879C55.3205 39.5 55.6564 39.6867 56.0679 39.8479C56.4879 40.0092 56.9918 40.1746 57.5797 40.3443C58.4615 40.5904 59.2132 40.8535 59.8347 41.1335C60.4562 41.4135 60.9601 41.7402 61.3464 42.1136C61.7412 42.487 62.0267 42.9325 62.2031 43.4501C62.3879 43.9593 62.4803 44.5745 62.4803 45.2957C62.4803 46.1867 62.3669 46.9632 62.1401 47.6251C61.9133 48.2785 61.5522 48.8258 61.0567 49.267C60.5612 49.7083 59.9229 50.035 59.1418 50.2471C58.3608 50.4678 57.4201 50.5781 56.3199 50.5781C55.6648 50.5781 55.0475 50.5272 54.468 50.4253C53.8885 50.332 53.3846 50.2259 52.9563 50.1071C52.444 49.9629 51.9778 49.8016 51.5579 49.6234Z" fill="#284A33"/>
          <path d="M68.6592 35.1002C68.0294 35.1087 67.4583 35.1172 66.9459 35.1257C66.442 35.1341 66.0095 35.1469 65.6484 35.1638C65.2284 35.1808 64.8547 35.1978 64.5272 35.2148C64.5104 35.1129 64.4978 35.0111 64.4894 34.9093C64.4642 34.7311 64.4516 34.5104 64.4516 34.2474C64.4516 34.0946 64.46 33.9122 64.4768 33.7001C64.502 33.4794 64.5439 33.2333 64.6027 32.9618H75.8148C75.8232 33.0467 75.8316 33.1358 75.84 33.2291C75.8484 33.3055 75.8568 33.3946 75.8652 33.4964C75.8736 33.5897 75.8778 33.6831 75.8778 33.7764C75.8778 33.9461 75.861 34.1668 75.8274 34.4383C75.8022 34.7099 75.7518 34.9644 75.6763 35.202C75.6091 35.1935 75.4327 35.1851 75.1471 35.1766C74.87 35.1596 74.534 35.1469 74.1393 35.1384C73.7446 35.1299 73.3163 35.1214 72.8543 35.1129C72.3924 35.1044 71.9431 35.1002 71.5064 35.1002V50.2471H68.6592V35.1002Z" fill="#284A33"/>
          <path d="M56.8418 54.4155H62.336C62.336 54.4485 62.3384 54.4839 62.3431 54.5217C62.3478 54.5548 62.3501 54.5925 62.3501 54.635C62.3548 54.6728 62.3572 54.7153 62.3572 54.7625C62.3572 54.8428 62.3407 54.9655 62.3078 55.1308C62.2796 55.2913 62.2138 55.4778 62.1103 55.6903C61.7248 55.6761 61.3251 55.662 60.9113 55.6478C60.5587 55.6384 60.1637 55.6289 59.7264 55.6195C59.2939 55.6053 58.866 55.5982 58.4428 55.5982V58.7357C58.5698 58.7357 58.7179 58.7357 58.8871 58.7357C59.0564 58.731 59.2351 58.7263 59.4232 58.7216C59.6113 58.7169 59.804 58.7121 60.0015 58.7074C60.2037 58.698 60.3988 58.6909 60.5869 58.6862C61.0289 58.672 61.4897 58.6578 61.9693 58.6437C61.9693 58.6814 61.9716 58.7216 61.9763 58.7641C61.981 58.8019 61.9834 58.8467 61.9834 58.8986C61.9881 58.9459 61.9904 58.9954 61.9904 59.0474C61.9904 59.0899 61.9787 59.1796 61.9552 59.3165C61.9364 59.4534 61.8894 59.6494 61.8141 59.9043C61.3157 59.9043 60.8455 59.902 60.4035 59.8973C60.2155 59.8973 60.0227 59.8973 59.8252 59.8973C59.6324 59.8973 59.449 59.8973 59.2751 59.8973C59.1011 59.8925 58.9412 59.8902 58.7955 59.8902C58.6497 59.8902 58.5322 59.8902 58.4428 59.8902V64.0334H56.8418V54.4155Z" fill="#284A33"/>
          <path d="M63.743 53.8418H65.2029V62.8436L65.619 63.141V64.0334H65.217L65.2029 64.0192V64.0334C64.7374 64.0334 64.3777 63.939 64.1238 63.7501C63.8699 63.5612 63.743 63.2496 63.743 62.8152V53.8418Z" fill="#284A33"/>
          <path d="M66.9625 60.4143C66.9625 59.791 67.0448 59.241 67.2093 58.7641C67.3786 58.2872 67.6137 57.8882 67.9146 57.5671C68.2203 57.2461 68.5823 57.0029 69.0008 56.8377C69.424 56.6724 69.8895 56.5898 70.3973 56.5898C70.9192 56.5898 71.3894 56.6677 71.8079 56.8235C72.2263 56.9746 72.5813 57.2059 72.8728 57.5176C73.1644 57.8292 73.3877 58.2187 73.5429 58.6862C73.698 59.1489 73.7756 59.6919 73.7756 60.3151C73.7756 60.9384 73.6957 61.4908 73.5358 61.9724C73.3807 62.454 73.155 62.8577 72.8587 63.1835C72.5672 63.5093 72.2122 63.7572 71.7937 63.9272C71.38 64.0924 70.9145 64.175 70.3973 64.175C69.8612 64.175 69.3793 64.0971 68.9514 63.9413C68.5282 63.7808 68.1685 63.5447 67.8723 63.2331C67.5808 62.9167 67.3551 62.5248 67.1952 62.0574C67.0401 61.5852 66.9625 61.0375 66.9625 60.4143ZM70.3973 63.0064C70.7076 63.0064 70.9756 62.9403 71.2013 62.8081C71.4317 62.6712 71.6198 62.4847 71.7655 62.2486C71.9113 62.0078 72.0194 61.7245 72.09 61.3987C72.1605 61.0682 72.1958 60.707 72.1958 60.3151C72.1958 59.47 72.0524 58.8255 71.7655 58.3816C71.4787 57.9378 71.0226 57.7159 70.3973 57.7159C70.0822 57.7159 69.8072 57.7843 69.5721 57.9213C69.3417 58.0535 69.1489 58.24 68.9937 58.4808C68.8433 58.7216 68.7304 59.0072 68.6552 59.3378C68.58 59.6683 68.5423 60.0271 68.5423 60.4143C68.5423 61.2689 68.6928 61.9158 68.9937 62.3549C69.2994 62.7893 69.7672 63.0064 70.3973 63.0064Z" fill="#284A33"/>
          <path d="M74.9921 60.4143C74.9921 59.791 75.0744 59.241 75.239 58.7641C75.4082 58.2872 75.6433 57.8882 75.9443 57.5671C76.2499 57.2461 76.6119 57.0029 77.0304 56.8377C77.4536 56.6724 77.9191 56.5898 78.4269 56.5898C78.9488 56.5898 79.419 56.6677 79.8375 56.8235C80.256 56.9746 80.611 57.2059 80.9025 57.5176C81.194 57.8292 81.4173 58.2187 81.5725 58.6862C81.7277 59.1489 81.8053 59.6919 81.8053 60.3151C81.8053 60.9384 81.7253 61.4908 81.5655 61.9724C81.4103 62.454 81.1846 62.8577 80.8884 63.1835C80.5969 63.5093 80.2419 63.7572 79.8234 63.9272C79.4096 64.0924 78.9441 64.175 78.4269 64.175C77.8909 64.175 77.4089 64.0971 76.981 63.9413C76.5579 63.7808 76.1982 63.5447 75.9019 63.2331C75.6104 62.9167 75.3847 62.5248 75.2249 62.0574C75.0697 61.5852 74.9921 61.0375 74.9921 60.4143ZM78.4269 63.0064C78.7372 63.0064 79.0052 62.9403 79.2309 62.8081C79.4613 62.6712 79.6494 62.4847 79.7952 62.2486C79.9409 62.0078 80.0491 61.7245 80.1196 61.3987C80.1901 61.0682 80.2254 60.707 80.2254 60.3151C80.2254 59.47 80.082 58.8255 79.7952 58.3816C79.5083 57.9378 79.0523 57.7159 78.4269 57.7159C78.1119 57.7159 77.8368 57.7843 77.6017 57.9213C77.3713 58.0535 77.1785 58.24 77.0234 58.4808C76.8729 58.7216 76.7601 59.0072 76.6848 59.3378C76.6096 59.6683 76.572 60.0271 76.572 60.4143C76.572 61.2689 76.7224 61.9158 77.0234 62.3549C77.329 62.7893 77.7968 63.0064 78.4269 63.0064Z" fill="#284A33"/>
          <path d="M84.3477 56.7173L85.0742 57.4822C85.1259 57.3641 85.1917 57.2532 85.2716 57.1493C85.3563 57.0407 85.4527 56.9463 85.5608 56.866C85.6737 56.7857 85.7983 56.722 85.9346 56.6748C86.0757 56.6275 86.2285 56.6039 86.3931 56.6039C86.5294 56.6039 86.6611 56.6157 86.788 56.6394C86.915 56.6582 87.0537 56.6937 87.2041 56.7456C87.2088 56.755 87.2135 56.7928 87.2182 56.8589C87.2276 56.925 87.2324 57.0076 87.2324 57.1068C87.2324 57.1823 87.2276 57.272 87.2182 57.3759C87.2088 57.4751 87.1924 57.579 87.1689 57.6876C87.1501 57.7914 87.1195 57.8953 87.0772 57.9992C87.0396 58.1031 86.9902 58.1928 86.9291 58.2683L86.7951 58.3037C86.701 58.2565 86.5952 58.2164 86.4777 58.1833C86.3648 58.1503 86.2473 58.1337 86.125 58.1337C85.937 58.1337 85.7794 58.1479 85.6525 58.1762C85.5255 58.1998 85.4221 58.2258 85.3422 58.2541C85.2481 58.2872 85.1729 58.325 85.1165 58.3675V64.0334H83.6071V58.0912L83.05 57.5176V56.7173H84.3477Z" fill="#284A33"/>
          <path d="M88.1879 63.7076C88.1879 63.599 88.1973 63.481 88.2161 63.3535C88.2302 63.2449 88.2514 63.1221 88.2796 62.9852C88.3125 62.8436 88.3595 62.6972 88.4206 62.5461C88.6275 62.6264 88.8438 62.6972 89.0695 62.7586C89.2623 62.8105 89.4715 62.8601 89.6972 62.9073C89.9229 62.9498 90.1463 62.971 90.3672 62.971C90.5647 62.971 90.7481 62.964 90.9174 62.9498C91.0866 62.9356 91.2324 62.8979 91.3547 62.8365C91.4816 62.7704 91.5803 62.6736 91.6509 62.5461C91.7214 62.4139 91.7567 62.2321 91.7567 62.0007C91.7567 61.7222 91.6697 61.5026 91.4957 61.3421C91.3264 61.1815 91.0302 61.0611 90.607 60.9809C90.1698 60.8959 89.8007 60.7826 89.4997 60.6409C89.2035 60.4993 88.9614 60.3364 88.7733 60.1522C88.5899 59.9634 88.4559 59.7533 88.3713 59.5219C88.2913 59.2905 88.2514 59.0427 88.2514 58.7782C88.2514 58.3816 88.3148 58.044 88.4418 57.7655C88.5687 57.4869 88.7521 57.2626 88.9919 57.0926C89.2364 56.9179 89.5373 56.7928 89.8947 56.7173C90.2567 56.637 90.6705 56.5969 91.136 56.5969C91.4604 56.5969 91.7473 56.6205 91.9965 56.6677C92.2504 56.7102 92.462 56.7574 92.6312 56.8093C92.8287 56.8707 93.0003 56.9415 93.1461 57.0218C93.132 57.1257 93.1061 57.239 93.0685 57.3618C93.0356 57.4656 92.9909 57.5837 92.9345 57.7159C92.8828 57.8481 92.8123 57.9827 92.7229 58.1196C92.596 58.044 92.4502 57.9779 92.2856 57.9213C92.1446 57.8693 91.9753 57.8245 91.7778 57.7867C91.5803 57.7442 91.3547 57.723 91.1007 57.723C90.9033 57.723 90.7199 57.7324 90.5506 57.7513C90.3861 57.7702 90.2426 57.8127 90.1204 57.8788C90.0028 57.9449 89.9112 58.0464 89.8453 58.1833C89.7795 58.3155 89.7466 58.4973 89.7466 58.7287C89.7466 58.842 89.7607 58.9459 89.7889 59.0403C89.8218 59.13 89.8829 59.2126 89.9723 59.2882C90.0663 59.3637 90.1956 59.4345 90.3602 59.5006C90.5295 59.562 90.7528 59.6234 91.0302 59.6848C91.4628 59.7792 91.8225 59.8878 92.1093 60.0106C92.4008 60.1333 92.6312 60.2821 92.8005 60.4568C92.9745 60.6315 93.0967 60.8369 93.1673 61.0729C93.2425 61.3043 93.2801 61.5805 93.2801 61.9016C93.2801 62.2463 93.226 62.5579 93.1179 62.8365C93.0097 63.115 92.8405 63.3535 92.6101 63.5518C92.3797 63.7501 92.0835 63.9036 91.7214 64.0122C91.3594 64.1207 90.9221 64.175 90.4096 64.175C90.0804 64.175 89.7795 64.1514 89.5068 64.1042C89.2388 64.057 89.006 64.0027 88.8085 63.9413C88.5781 63.8752 88.3713 63.7973 88.1879 63.7076Z" fill="#284A33"/>
        </svg>
      </div>

      <b-carousel
        id="carousel-fade"
        class="fd-carousel-fade"
        :interval="4000"
        :no-hover-pause="true"
        fade
        indicators
      >
        <b-carousel-slide
          v-for="(item, index) in carouselData"
          :key="index"
          class="fd-relative"
        >
          <template #img>
            <img :src="item.src" alt="image">
            <div class="fd-mt-12">
              <h1 class="fd-text-theme-2 fd-text-5xl fd-font-bold">{{ item.title }}</h1>
              <p class="fd-text-theme-3 fd-text-xl fd-mt-8">{{ item.body }}</p>
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div>
    <div class="fd-w-full fd-h-full fd-flex fd-items-center fd-px-36">
      <div class="fd-w-full">
        <h2 class="fd-text-theme-2 fd-text-4xl fd-font-bold">{{ $t('auth.resetPassword') }}</h2>
        <span class="fd-block fd-text-theme-3 fd-text-sm fd-mb-12 fd-mt-4">{{ $t('auth.resetDescription') }}</span>
        <validation-observer ref="loginValidation">
          <b-form
            class="auth-login-form mt-1"
            @submit.prevent
          >
            <!-- email -->
            <b-form-group
              :label="$t('auth.email')"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('auth.email')"
                rules="required"
              >
                <b-form-input
                  id="email"
                  type="email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false:null"
                  name="email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group
              :label="$t('auth.newPassword')"
              label-for="password"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('auth.newPassword')"
                rules="required"
                vid="password"
              >
                <b-form-input
                  id="password"
                  type="password"
                  v-model="password"
                  :state="errors.length > 0 ? false:null"
                  name="password"
                  :placeholder="$t('auth.resetPlaceholder')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Confirm Password -->
            <b-form-group
              :label="$t('auth.confirmPassword')"
              label-for="confirmPassword"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('auth.confirmPassword')"
                rules="required|confirmed:password"
              >
                <b-form-input
                  id="confirmPassword"
                  type="password"
                  v-model="password_confirmation"
                  :state="errors.length > 0 ? false:null"
                  name="password"
                  :placeholder="$t('auth.resetPlaceholder')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit buttons -->
            <button
              type="submit"
              class="fd-block fd-mt-8 fd-w-full fd-rounded-lg fd-py-3 fd-bg-theme-4 fd-text-white"
              @click="validationForm"
            >
              {{ $t('auth.saveNewPassword') }}
            </button>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { BCarousel, BCarouselSlide, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton } from 'bootstrap-vue'
import { required, email, confirmed } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import toast from "@/mixins/toast";

export default {
  name: "ResetPassword",
  components: {
    BCarousel, BCarouselSlide, BForm, BFormGroup, BFormInput, BLink,
    BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg,
    BButton, VuexyLogo, ValidationProvider, ValidationObserver,
  },
  mixins: [togglePasswordVisibility, toast],
  data() {
    return {
      status: '',
      userEmail: '',
      password: '',
      password_confirmation: '',
      token: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      confirmed
    }
  },
  beforeCreate() {
    if (localStorage.getItem('token') !== null) {
      return this.$router.push({ name: 'projects' })
    }
    if (!this.$route.query.token) {
      this.$router.push({ name: 'login' })
    }
  },
  created() {
    this.token = this.$route.query.token
  },
  computed: {
    carouselData() {
      return [
        {
          src: 'https://picsum.photos/id/1029/525/500',
          title: 'Find your sweet home',
          body: 'Lorem ipsum dolor consectetur sit amet, consectetur adipiscing elit.'
        },
        {
          src: 'https://picsum.photos/id/164/525/500',
          title: 'Test2',
          body: 'Test lorem'
        }
      ]
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.$store.dispatch('auth/resetPassword', {
            email: this.userEmail,
            password: this.password,
            password_confirmation: this.password_confirmation,
            token: this.token,
          })
            .then(() => {
              this.makeToast(this.$t('toastMessages.resetPassword'))
              this.$router.push({ name: 'login' })
            })
        }
      })
    },
    backToLogin() {
      return this.$router.push({ name: 'login' })
    }
  },
}
</script>

<style lang="scss" scoped>
.fd-carousel-fade {
  width: 525px !important;
  height: 700px !important;

  img {
    border-bottom-right-radius: 80px !important;
    width: 525px !important;
    height: 500px !important;
  }
  ::v-deep .carousel-inner {
    width: 525px !important;
    height: 700px !important;
  }
}
</style>
